/**
 * External dependencies
 */
export default class ConnectionLocation {
    constructor(id, cscom) {
        if (!(this instanceof ConnectionLocation)) {
            return new ConnectionLocation(id, cscom);
        }
        this.cscom = cscom;
        this.id = id;

        if (this.id) {
            this.path = `/user-site-api/user-connection-location-details/${this.id}`;
        } else {
            this.path = `/user-site-api/user-connection-location-details`;
        }
    }

    getConnectionLocations() {
        return this.cscom.req.get(this.path);
    }
}
